import React from "react";
import { useTranslation } from "react-i18next";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useMyHrMaritalStatuses } from "my-hr/hooks";
interface OcFormEditorMaritalStatusSelectorProps {
  name: string;
  value: { code: string; name: string };
  label: string;
  onChange: (name: string, value: { code: string; name: string }) => void;
}

export const OcFormEditorMaritalStatusSelector: React.FC<
  OcFormEditorMaritalStatusSelectorProps
> = ({ name, value, label, onChange }) => {
  const { t } = useTranslation();
  const { data: maritalStatuses }: { data: { code: string; name: string }[] } =
    useMyHrMaritalStatuses();
  const getMaritalStatus = (code: string) =>
    maritalStatuses.find(
      (item: { code: string; name: string }) => item.code === code,
    );

  return (
    <Box paddingTop="36px">
      <FormControl
        id={"gender-form-control"}
        variant="outlined"
        style={{
          height: "56px",
          width: "100%",
        }}
      >
        <InputLabel htmlFor={"gender-select"}>{t(label)}</InputLabel>
        <Select
          id={name}
          name={name}
          value={
            maritalStatuses.some(
              (item: { code: string; name: string }) =>
                item.code === value.code,
            )
              ? value.code
              : ""
          }
          label={t(label)}
          defaultValue=""
          onChange={(e) => {
            const selectedStatus = getMaritalStatus(e.target.value);
            if (selectedStatus) {
              onChange(name, selectedStatus);
            }
          }}
        >
          {maritalStatuses?.map((item, code) => (
            <MenuItem key={`${item}-${code}`} id={`${code}`} value={item?.code}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default OcFormEditorMaritalStatusSelector;
